import { Control } from 'react-hook-form';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import {
  DistanceRangeFromField,
  DistanceRangeToField,
  ExpensesMaxField,
  ExpensesNominalField,
  ExpensesPerDistanceField,
  ValidFromField,
  ValidToField
} from './innerView/editTravelLines/components/TravelLineFields';
import { Grid } from '@mui/material';

interface Props {
  control: Control<any>;
}

const DetailsArrangementSection: React.FC<Props> = ({ control }) => {
  return (
    <MultiStepForm.Section title={'Details'}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DistanceRangeFromField name={`travelSetLine.distanceRangeFrom`} />
        </Grid>
        <Grid item xs={6}>
          <DistanceRangeToField name={`travelSetLine.distanceRangeTo`} />
        </Grid>
        <Grid item xs={4}>
          <ExpensesPerDistanceField
            name={`travelSetLine.expensesPerDistance`}
          />
        </Grid>
        <Grid item xs={4}>
          <ExpensesNominalField name={`travelSetLine.expensesNominal`} />
        </Grid>
        <Grid item xs={4}>
          <ExpensesMaxField name={`travelSetLine.expensesMax`} />
        </Grid>
        <Grid item xs={6}>
          <ValidFromField name={`travelSetLine.from`} control={control} />
        </Grid>
        <Grid item xs={6}>
          <ValidToField name={`travelSetLine.to`} control={control} />
        </Grid>
      </Grid>
    </MultiStepForm.Section>
  );
};

export default DetailsArrangementSection;
